import React from 'react';
import { Box, Typography, Stack, Tooltip, IconButton, Skeleton } from '@mui/material';

const ProfileNavbarSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ cursor: 'default' }}>
        <Skeleton variant='circular' width={35} height={35} />
      </div>
      <Box>
        <Stack direction={'row'} alignItems={'center'} ml={1}>
          <Typography>
            <Skeleton width={150} />
          </Typography>
        </Stack>
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
          <Tooltip title='Loading status'>
            <Box
              sx={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                backgroundColor: 'lightgray',
                mr: 1,
              }}
            />
          </Tooltip>
          <Typography fontSize={'14px'}>
            <Skeleton width={120} />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileNavbarSkeleton;
